import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ami-list-view-wrapper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-view-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListViewWrapperComponent {
  @Input() title?: string = '';
}
